import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../api/mutations'
import {invalidateHcemQuery} from '../../../api/queryHelpers'
import {notifyIfErrorMessage} from '../../../common'
import {ErrorResponse} from '../../../interfaces/api'

export const useCancelMaterialOrder = () => {
  const {t} = useTranslation()
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  return useMutation<
    void,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.cancelMaterialOrder>[0]
  >({
    mutationFn: mutations.cancelMaterialOrder,
    mutationKey: ['cancelMaterialOrder'],
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.message, raiseError, notify)
    },
    onSuccess: () => {
      notify('success', t('success.cancelMaterialOrder'))
    },
    onSettled: () => {
      invalidateHcemQuery('materialOrders')
      invalidateHcemQuery('stockDevelopment')
    }
  })
}
